import { capitalize } from "@s-libs/micro-dash";

import { Grades } from "@/search/NewSearchPageMVP/NewSearchPageMVP.constants";
import { AgathaSchemaParamsEnum } from "@/search/NewSearchPageMVP/types/IParametersSchema";
import { IReadingSkill } from "@/search/NewSearchPageMVP/types/IReadingSkill";
import { IStandard } from "@/search/NewSearchPageMVP/types/IStandard";

enum InstructionalFeatureEnum {
  power_words = "power_words",
  has_formative = "has_formative",
}

const INSTRUCTIONAL_FEATURES_VALUE_TEXT_MAP: {
  [InstructionalFeatureEnum.has_formative]: string;
  [InstructionalFeatureEnum.power_words]: string;
} = {
  has_formative: "Formatives",
  power_words: "Power Words",
};

export enum ContentMaturitiesEnum {
  lower_elementary = "lower_elementary",
  upper_elementary = "upper_elementary",
  middle_school = "middle_school",
  high_school = "high_school",
}

const CONTENT_MATURITIES_VALUE_TEXT_MAP = {
  [ContentMaturitiesEnum.lower_elementary]: "Lower elementary",
  [ContentMaturitiesEnum.upper_elementary]: "Upper elementary",
  [ContentMaturitiesEnum.middle_school]: "Middle school",
  [ContentMaturitiesEnum.high_school]: "High school",
};

const GRADE_LEVEL_VALUE_TEXT_MAP = {
  [Grades.Kindergarten]: "Kindergarten",
  [Grades.GRADE_1]: "1st grade",
  [Grades.GRADE_2]: "2nd grade",
  [Grades.GRADE_3]: "3rd grade",
  [Grades.GRADE_4]: "4th grade",
  [Grades.GRADE_5]: "5th grade",
  [Grades.GRADE_6]: "6th grade",
  [Grades.GRADE_7]: "7th grade",
  [Grades.GRADE_8]: "8th grade",
  [Grades.GRADE_9]: "9th grade",
  [Grades.GRADE_10]: "10th grade",
  [Grades.GRADE_11]: "11th grade",
  [Grades.GRADE_12]: "12th grade",
};

export const getFilterChipText = (
  paramName: string,
  paramValue: string,
  readingSkills: IReadingSkill[],
  selectedStandards: IStandard[],
) => {
  if (paramName === AgathaSchemaParamsEnum.instructional_features)
    return INSTRUCTIONAL_FEATURES_VALUE_TEXT_MAP[
      paramValue as InstructionalFeatureEnum
    ];
  if (paramName === AgathaSchemaParamsEnum.content_maturities)
    return CONTENT_MATURITIES_VALUE_TEXT_MAP[
      paramValue as ContentMaturitiesEnum
    ];
  if (paramName === AgathaSchemaParamsEnum.grade_level)
    return GRADE_LEVEL_VALUE_TEXT_MAP[paramValue as Grades];
  if (paramName === AgathaSchemaParamsEnum.related_to_standards) {
    const selectedStandard = selectedStandards.find(
      (standard) => standard.content_id === paramValue,
    );
    const title = selectedStandard?.display_fields.number_enhanced;
    return title || "";
  }
  if (paramName === AgathaSchemaParamsEnum.reading_skills) {
    const readingSkill = readingSkills.find(({ slug }) => slug === paramValue);
    return capitalize(readingSkill?.text || "");
  }
  if (paramName === AgathaSchemaParamsEnum.lexile_level_range) {
    const [min, max] = paramValue.split("-") as [string, string];
    return `${min}L - ${max}L`;
  }
  return paramValue;
};
